.auth {
  min-height: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  background: var(--bg);
}

.auth-hero {
  position: relative;
  overflow: hidden;
  padding: 48px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    radial-gradient(1200px 600px at 10% 0%, rgba(124, 111, 255, 0.55), transparent 60%),
    radial-gradient(900px 500px at 100% 100%, rgba(255, 224, 102, 0.35), transparent 55%),
    #1a1640;
  color: #fff;
}

.auth-hero .brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: -0.01em;
}

.auth-hero h1 {
  font-size: clamp(34px, 3.6vw, 52px);
  line-height: 1.05;
  letter-spacing: -0.03em;
  margin: 0 0 16px;
  white-space: pre-line;
  font-weight: 750;
}

.auth-hero p {
  max-width: 460px;
  font-size: var(--fs-6);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
  margin: 0;
}

.hero-board {
  position: relative;
  height: 300px;
  margin: 32px 0;
}

.hero-note {
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: var(--radius-2xs);
  padding: 12px;
  font-size: var(--fs-3);
  font-weight: 600;
  color: #1f2329;
  box-shadow: 0 12px 30px -10px rgba(0, 0, 0, 0.45);
  animation: float 7s ease-in-out infinite;
}

.hero-cursor {
  position: absolute;
  display: flex;
  align-items: flex-start;
  gap: 2px;
  animation: cursor-move 9s ease-in-out infinite;
}

.hero-cursor span {
  margin-top: 16px;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  font-size: var(--fs-1);
  font-weight: 650;
  color: #fff;
}

@keyframes float {
  50% {
    transform: translateY(-8px) rotate(-1deg);
  }
}

@keyframes cursor-move {
  0%,
  100% {
    transform: translate(0, 0);
  }
  40% {
    transform: translate(90px, 40px);
  }
  70% {
    transform: translate(30px, 90px);
  }
}

.auth-main {
  display: grid;
  place-items: center;
  padding: 32px 20px;
}

.auth-card {
  width: min(400px, 100%);
  display: grid;
  gap: 16px;
}

.auth-card h2 {
  font-size: 26px;
  letter-spacing: -0.02em;
  margin: 0;
  font-weight: 700;
}

.auth-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-3);
  font-size: var(--fs-2);
}
.auth-divider::before,
.auth-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-strong);
}

.auth-switch {
  text-align: center;
  color: var(--text-2);
  font-size: var(--fs-3);
}

.auth-note {
  padding: 12px 14px;
  border-radius: var(--radius);
  background: var(--accent-soft);
  color: var(--accent-text);
  font-weight: 500;
  line-height: 1.5;
}

.oauth-row {
  display: grid;
  gap: 8px;
}

@media (max-width: 860px) {
  .auth {
    grid-template-columns: 1fr;
  }
  .auth-hero {
    display: none;
  }
}

.legal-checks {
  display: grid;
  gap: 10px;
}

.legal-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: var(--fs-3);
  line-height: 1.45;
  color: var(--text-2);
  cursor: pointer;
}

.legal-check input {
  flex: none;
  width: 16px;
  height: 16px;
  margin: 1px 0 0;
  accent-color: var(--accent);
}

.consent-gate {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 24px 16px;
  overflow: auto;
  background: var(--bg);
}

.legal-list {
  margin: 0;
  padding-left: 18px;
  display: grid;
  gap: 6px;
  font-size: var(--fs-4);
  line-height: 1.45;
}

.connect-logos {
  display: flex;
  align-items: center;
  gap: 12px;
}
.connect-dots {
  color: var(--text-3);
  font-weight: 700;
  letter-spacing: 2px;
}
.connect-app {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-md);
  background: var(--surface-2);
  color: var(--text-2);
}
.connect-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.connect-row select {
  width: 200px;
}
